var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.4 7 16-4c.4-.1.7.2.6.6l-4 16c-.1.5-.8.5-1 0l-2.1-7c-.1-.3 0-.7.2-.9l4.4-5.9c.1-.2-.1-.4-.3-.3L8.3 9.9c-.3.2-.6.3-.9.2L.4 8c-.5-.1-.5-.9 0-1z"
  })));
};
export default SvgSend;